<div class="copo-datacenter-filter">
	<label class="filter-number-label" for="filter-dimensions-thickness-input" translate>filter.dimensions.thickness</label>
	<div>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
			<input matInput id="filter-dimensions-thickness-input" type="text" spellcheck="false" autocomplete="off" [formControl]="thicknessTextControl" [placeholder]="('filter.dimensions.thickness' | translate) + '...'">
			<button type="button" *ngIf="thicknessTextControl.value" matSuffix mat-icon-button (click)="resetThickness()" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
		</mat-form-field>
		<div class="info-invalid-value" *ngIf="!thicknessTextControl.valid" translate>datacenter-filter.invalid-number</div>
	</div>
	<label class="filter-number-label" for="filter-dimensions-width-input" translate>filter.dimensions.width</label>
	<div>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
			<input matInput id="filter-dimensions-width-input" type="text" spellcheck="false" autocomplete="off" [formControl]="widthTextControl" [placeholder]="('filter.dimensions.width' | translate) + '...'">
			<button type="button" *ngIf="widthTextControl.value" matSuffix mat-icon-button (click)="resetWidth()" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
		</mat-form-field>
		<div class="info-invalid-value" *ngIf="!widthTextControl.valid" translate>datacenter-filter.invalid-number</div>
	</div>
	<label class="filter-number-label" for="filter-dimensions-length-input" translate>filter.dimensions.length</label>
	<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
		<input matInput id="filter-dimensions-length-input" type="text" spellcheck="false" autocomplete="off" [formControl]="lengthTextControl" [placeholder]="('filter.dimensions.length' | translate) + '...'">
		<button type="button" *ngIf="lengthTextControl.value" matSuffix mat-icon-button (click)="resetLength()" tabindex="-1">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</mat-form-field>
	<div class="info-invalid-value" *ngIf="!lengthTextControl.valid" translate>datacenter-filter.invalid-number</div>
</div>
